/**
 * Custom DataGrid aggregation functions
 */

import {
  GridAggregationFunction,
  GridAggregationParams,
} from "@mui/x-data-grid-premium";
import { isValidDate } from "utils/common";

/**
 * Custom aggregation function for Minimum Date that ignores invalid values
 */
export const minDateAggregation: GridAggregationFunction<
  Date | null,
  Date | null
> = {
  apply: (params: GridAggregationParams<Date | null>): Date | null => {
    const validDates = params.values.filter(isValidDate);
    if (validDates.length === 0) {
      return null;
    }

    const minValidDate = validDates.reduce((min, current) => {
      return min < current ? min : current;
    });

    return minValidDate;
  },
  valueFormatter: (value: Date | null | undefined): string => {
    if (value instanceof Date && !isNaN(value.getTime())) {
      return value.toLocaleDateString();
    }
    return "--";
  },
  columnTypes: ["date", "dateTime"],
  label: "minDate",
};

/**
 * Custom aggregation function for Maximum Date that ignores invalid values
 */
export const maxDateAggregation: GridAggregationFunction<
  Date | null,
  Date | null
> = {
  apply: (params: GridAggregationParams<Date | null>): Date | null => {
    const validDates = params.values.filter(isValidDate);
    if (validDates.length === 0) {
      return null;
    }
    const maxValidDate = validDates.reduce((max, current) => {
      return max > current ? max : current;
    });
    return maxValidDate;
  },

  valueFormatter: (value: Date | null | undefined): string => {
    if (isValidDate(value)) {
      return value.toLocaleDateString();
    }
    return "--";
  },
  columnTypes: ["date", "dateTime"],
  label: "maxDate",
};
